import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { fadeUp, staggerContainer, viewportOnce } from "../common/Motion";

const Testimonials = () => {
  const reduceMotion = useReducedMotion();
  return (
  <section className="section testimonial-section">
    <motion.div className="site-shell quote-wrap" variants={reduceMotion ? undefined : staggerContainer} initial={reduceMotion ? false : "hidden"} whileInView="visible" viewport={viewportOnce}>
      <motion.p variants={fadeUp} className="eyebrow">Our AI promise</motion.p>
      <motion.blockquote variants={fadeUp}>“AI should not add another layer of complexity. It should make your organization clearer, faster, and more capable.”</motion.blockquote>
      <motion.div variants={staggerContainer} className="principles"><motion.span variants={fadeUp}>Useful over impressive</motion.span><motion.span variants={fadeUp}>Grounded in your data</motion.span><motion.span variants={fadeUp}>Humans stay in control</motion.span><motion.span variants={fadeUp}>Measured in production</motion.span></motion.div>
    </motion.div>
  </section>
  );
};
export default Testimonials;
